<template>
  <div>
    <component
      class="screen-layout"
      :is="template"
      :meals="meals"
      :style="fontSizeStyle"
    />
  </div>
</template>

<script>
import * as templates from "./templates"

export default {
  name: "screen-layout",
  props: ["meals", "template"],
  components: {
    ...templates
  },
  data() {
    return {
      containerWidthInPx: 1
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  computed: {
    fontSizeStyle() {
      const size = this.containerWidthInPx * 0.008
      return `font-size: ${size}px`
    }
  },
  methods: {
    handleResize() {
      this.containerWidthInPx = this.$el.clientWidth
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-layout {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
</style>
